<template>
  <section>
    <form class="search-form">
      <label class="input-cont">
        <search-icon class="icon"></search-icon>
        <input type="text" v-model="filter" :placeholder="$t('users.thingSearch')">
      </label>
    </form>
    <ul class="things-list" >
      <!--<user-info-thing v-for="item in thingsList"-->
                       <!--:thing="item"-->
                       <!--:email="user.contacts.email"-->
                       <!--:key="item.id"></user-info-thing>-->
      <user-info-thing v-for="item in thingsList"
                       :thing="item"
                       :email="user.contacts.email"
                       :key="item.id"></user-info-thing>
    </ul>
  </section>
</template>

<script>
  import {searchFormInfo} from "../../../mixins/searchFormInfo";
  import {mapState} from 'vuex'
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {filters} from "../../../mixins/filters";
  import chevronIcon from '../../Svg/chevronIcon'
  import userInfoThing from './userInfoThing'

  export default {
    name: 'userInfThings',
    mixins: [searchFormInfo, tokenAndRoute, filters],
    props: {
      user: {
        type: Object
      }
    },
    components: {
      chevronIcon,
      userInfoThing
    },
    computed: {
      ...mapState({
        things: state => state.things.ownedThing
      }),
      thingsList() {
        let arrThings = [];

        let roleId = this.routeId;
        let devices = this.things.devices;
        let groups = this.things.groups;

        function findInDevices(arr, user) {
          findItem(arr);

          function findItem(a) {
            for (let  i = 0; i < a.length; i++) {
              let item = a[i];
              if (item.permissions) {
                for (let j = 0; j < item.permissions.length; j++) {
                  let permission = item.permissions[j];
                  if (permission.role.owner && permission.role.owner.email == user.contacts.email) {
                    arrThings.push({
                      name: item.name,
                      level: permission.value,
                      id: item.id,
                      permissions: item.permissions
                    })
                  }
                }
                ;
              }
              if (item.included_devices && item.included_devices.length > 0) {
                findItem(item.included_devices)
              }
            }
          }
        };
        findInDevices(devices, this.user);

        function findInGroups(arr, user) {
          findItem(arr)

          function findItem(a) {
            a.forEach(item => {
              findInDevices(item.devices, user);

              if (item.groups.length > 0) {
                findItem(item.groups)
              }
            });
          }
        };

        findInGroups(groups, this.user);
        arrThings = this.delDouble(arrThings, 'id');
        arrThings = arrThings.filter(item => {
          let filter = this.filter.toLowerCase();
          if (String(item.name).toLowerCase().includes(filter)) {
            return item
          }
        });

        return arrThings
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-form {
    position: relative;
    width: calc(100% + 60px);
    margin-left: -30px;
    margin-bottom: 30px;

    .icon {
      position: absolute;
      left: 30px;
      top: 0;
      background: none;
      width: 20px;
    }
  }

  .permission-title {
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    opacity: .5;
    cursor: pointer;
    user-select: none;
  }

  .item-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 22px;
    padding: 0 20px;
    padding-right: 30px;

    svg {
      cursor: pointer;
      transition: $anim;
    }

    .opened {
      transform: rotate(180deg);
    }
  }
</style>
